// imports
import JsonApiModel from '$dependencies/JsonApiModel';

// private static properties
const API_DICTIONARY = {
	uuid: 'id',
};

const FIELDS = {
	id: { type: String, default: '', identifier: true },
	name: { type: String, default: '' },
};

// class definition
export default class BinColorModel extends JsonApiModel {
	// constructor
	constructor(args = {}) {
		// clone args to do some modifications
		args = Object.assign({}, args);
		args.entityType = 'taxonomy_term--bin_colors';
		args.fields = FIELDS;

		// json api settings
		args.jsonApi = Object.assign(args.jsonApi || {}, {
			dictionary: API_DICTIONARY,
		});

		// call super constructor
		super(args);
	}

	get urlKey() {
		return this.name.toLowerCase().replace(' ', '-');
	}
}
